import React, { Component } from 'react';
import IndexPage from './Components/IndexPage';
import { compose, bindActionCreators } from 'redux';// Creates the Central Redux Store
import * as Actions from './Reducers/actions';
import { connect } from 'react-redux';

class App extends Component {

  render() {

    return (
      <div className="App" >
          <IndexPage {...this.props}></IndexPage>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stateReducer: state.stateReducer,
  appSettingsReducer: state.appSettingsReducer,
  ordersReducer: state.ordersReducer,
  authReducer: state.authReducer,
  actionMenuReducer: state.actionMenuReducer,
  subActionMenuReducer: state.subActionMenuReducer,
  sendableStatesReducer: state.sendableStatesReducer
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
  mapStateToProps,
  mapDispatchToProps
))(App);